import * as Cesium from "cesium";

export const showBBoxOnMap = (viewer, bboxCoords) => {
  if (!viewer || !Array.isArray(bboxCoords) || bboxCoords.length === 0) {
    console.warn("Invalid input for showBBoxOnMap");
    return;
  }

  // Flatten coords (use first ring of polygon)
  const coords = bboxCoords;
  const positions = coords.map(([lat, lon]) => Cesium.Cartesian3.fromDegrees(lon, lat));

  // Add polygon entity (semi-transparent blue)
  const polygonEntity = viewer.entities.add({
    polygon: {
      hierarchy: new Cesium.PolygonHierarchy(positions),
      material: Cesium.Color.BLUE.withAlpha(0.2), // blue with 20% opacity
      outline: true,
      outlineColor: Cesium.Color.BLUE,
    },
  });

  // Add red dashed polyline (outline)
  const polylineEntity = viewer.entities.add({
    polyline: {
      positions,
      width: 2,
      material: new Cesium.PolylineDashMaterialProperty({
        color: Cesium.Color.RED,
        dashLength: 12.0,
      }),
      clampToGround: false,
    },
  });

  // Compute bounding sphere with a scale factor (padding)
  const bs = Cesium.BoundingSphere.fromPoints(positions);
  viewer.camera.flyToBoundingSphere(bs, {
    duration: 1.5, // animation duration
    offset: new Cesium.HeadingPitchRange(
      0.0, // heading
      -0.5, // pitch (slightly tilted down)
      bs.radius * 5, // range (zoom out 5x the bbox radius)
    ),
  });

  // Set up one-time click handler to remove both polygon + polyline
  const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  handler.setInputAction(() => {
    viewer.entities.remove(polygonEntity); // remove polygon
    viewer.entities.remove(polylineEntity); // remove dashed outline
    handler.destroy(); // destroy handler after one click
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
};

export const createJsonFileForUpload = (data, filename) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  const file = new File([blob], filename, { type: "application/json" });
  return file;
};
